import isNil from 'lodash/isNil';
import React, {useCallback, useEffect, useRef} from 'react';
import {CheckmarkIcon} from '~library/svg/CheckmarkIcon';
import {emeraldWebText} from '~libSass/base/_exports.sass';

import './FontItem.sass';

export const FontItem = ({font = null, selected = false, onClick = () => {}, scroll = true}) => {
  if (isNil(font)) {
    return null;
  }

  const onClickHandler = useCallback(() => onClick(font), [font]);

  const ref = useRef();
  useEffect(() => {
    if (ref.current && selected && scroll) {
      ref.current.scrollIntoView({block: 'nearest', inline: 'nearest'});
    }
  }, []);

  return (
    <div
      ref={ref}
      className="font_item"
      onClick={onClickHandler}
      role="button"
      data-type={font.type}
    >
      <p
        key={`${font.name}-${font.weight}-${font.style}`}
        className={selected ? 'paragraph--selected' : ''}
        style={{
          fontFamily: font?.family,
          fontWeight: font?.weight ?? 'normal',
          fontStyle: font?.style ?? 'normal',
        }}
      >
        {font.name}
      </p>
      {!!selected && <CheckmarkIcon ratio={0.5} color={emeraldWebText} />}
    </div>
  );
};
